module.exports = __webpack_public_path__ + "static/img/6.ee80786.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/five/6.png
// module id = Ztfh
// module chunks = 1